const unlockedFeaturesDataset =[
  {featureName: "funStuff", minNbrMonths: 6, minCashAmt: 100, minMonthIncome: 100, 
      creditCriteria: false, level: 1},
  {featureName: "funStuff", minNbrMonths: 20, minCashAmt: 8000, minMonthIncome: 1000, 
      creditCriteria: false, level: 2},
  {featureName: "funStuff", minNbrMonths: 45, minCashAmt: 20000, minMonthIncome: 1500, 
     creditCriteria: false, level: 3},
  {featureName: "creditCard", minNbrMonths: 18, minCashAmt: 5000, minMonthIncome: 200, 
      creditCriteria: true, level: 1},
  {featureName: "creditCard", minNbrMonths: 24, minCashAmt: 7500, minMonthIncome: 500,
      creditCriteria: true, level: 2},
  {featureName: "creditCard", minNbrMonths: 36, minCashAmt: 15000, minMonthIncome: 1000, 
      creditCriteria: true, level: 3},
  {featureName: "creditCard", minNbrMonths: 48, minCashAmt: 20000, minMonthIncome: 1250, 
      creditCriteria: true, level: 4},
  {featureName: "creditCard", minNbrMonths: 72, minCashAmt: 30000, minMonthIncome: 2500, 
      creditCriteria: true, level: 5},
  {featureName: "timeWizard", minNbrMonths: 12, minCashAmt: 1000, minMonthIncome: 250, 
      creditCriteria: false, level: 1},
  {featureName: "timeWizard", minNbrMonths: 36, minCashAmt: 5000, minMonthIncome: 500, 
      creditCriteria: false, level: 2},
  {featureName: "timeWizard", minNbrMonths: 72, minCashAmt: 20000, minMonthIncome: 1000, 
      creditCriteria: false, level: 3},
  {featureName: "moneyBuilder", minNbrMonths: 1, minCashAmt: 5000, minMonthIncome: 500, 
      creditCriteria: false, level: 1},
  {featureName: "moneyBuilder", minNbrMonths: 8, minCashAmt: 5000, minMonthIncome: 1000, 
      creditCriteria: false, level: 2},
  {featureName: "moneyBuilder", minNbrMonths: 15, minCashAmt: 10000, minMonthIncome: 1500, 
      creditCriteria: false, level: 3}
];

export default unlockedFeaturesDataset;